import type { App } from 'vue'
import type { Router } from 'vue-router'
import * as Sentry from '@sentry/vue'

export type SentryOptions = {
  app: App
  router: Router
}

export const useSentry = (options: SentryOptions) => {
  Sentry.init({
    app: options.app,

    dsn: import.meta.env.VITE_SENTRY_DSN_PUBLIC,
    debug: import.meta.env.VITE_SENTRY_ENABLE_DEBUG === 'true',
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
    sampleRate: Number(import.meta.env.VITE_SENTRY_SAMPLE_RATE),
    ignoreErrors: [], // <-- https://docs.sentry.io/platforms/javascript/configuration/filtering/#using-ignore-errors
    ignoreTransactions: [], // <-- https://docs.sentry.io/platforms/javascript/configuration/filtering/#using-ignore-transactions
    enableTracing: import.meta.env.VITE_SENTRY_ENABLE_TRACING === 'true',
    tracesSampleRate: Number(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE),
    replaysSessionSampleRate: Number(
      import.meta.env.VITE_SENTRY_REPLAY_SESSION_SAMPLE_RATE,
    ),
    replaysOnErrorSampleRate: Number(
      import.meta.env.VITE_SENTRY_REPLAY_ON_ERROR_SAMPLE_RATE,
    ),

    integrations: [
      Sentry.browserTracingIntegration({
        router: options.router,
      }),
      Sentry.replayIntegration(),
    ],
    tracePropagationTargets: ['localhost', /^\/api/],
  })
}
